import React from "react";
import TextAtm from "../../../../atoms/TextAtm";
import PushOrg from "../../../../organisms/PushOrg";
var ErrorMessage = function ErrorMessage(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: 1
  }, /*#__PURE__*/React.createElement(TextAtm, {
    typography: "tiny1",
    color: "error"
  }, message));
};
export default ErrorMessage;